<template>
  <div v-if="!isSoldOut" class="main-container clear">
    <div class="bread">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">&gt;</span>
      <router-link :to="{ name: 'CourseShow', params: { id: course_id } }">
        课程详情
      </router-link>
      <span class="slash">&gt;</span>
      <span class="current">{{ course.title }}</span>
    </div>
    <div class="clear">
      <div ref="videoWrap" id="video-wrap" class="video-left f-left">
        <video
          id="videoplay"
          ref="videoplay"
          class="video video-js vjs-default-skin"
        ></video>
      </div>
      <div class="f-right chapters">
        <CourseChapter
          ref="chapter"
          :course="course"
          :currentPeriod="period_id"
          :tryText="''"
        ></CourseChapter>
      </div>
    </div>
  </div>
  <CourseSoldOut v-else></CourseSoldOut>
</template>
<script>
import CourseChapter from "../../components/CourseChapter.vue";
import CourseSoldOut from "../../components/CourseSoldOut.vue";

export default {
  name: "Video",
  components: {
    CourseChapter,
    CourseSoldOut,
  },
  data() {
    return {
      parent: this.$route.query.parent,
      course_type: "",
      course_id: "",
      period_id: "",
      video_id: "",
      course: {},
      timer: null,
      timesTimer: null,
      currentTime: 0,
      isSoldOut: false,
      isPlay: false,
      seconds: 0,
    };
  },
  async mounted() {
    this.$nextTick(async () => {
      this.$refs.videoWrap.addEventListener("contextmenu", event => {
        event.preventDefault();
      });
      await this.init();
      await this.play();
    });
  },
  methods: {
    async init() {
      this.clearTimer();
      this.isPlay = false;
      this.course_id = this.$route.query.course_id;
      this.course_type = this.$route.query.course_type;
      this.period_id = this.$route.query.period_id.toString();
      this.video_id = this.$route.query.video_id;
      this.parent = this.$route.query.parent;
      let data = await this.$http.get(
        "/api/app/courseInfo/basis_id=" + this.course_id,
        {},
        {
          onError: data => {
            if (data.msg == "你来晚了，该课程已下架") {
              this.isSoldOut = true;
            }
          },
        },
      );
      this.course = data.info;
      this.timesTimer = setInterval(() => {
        if (!this.isPlay) {
          return;
        }
        this.seconds++;
      }, 1000);
    },
    clearTimer() {
      if (this.timesTimer) {
        clearInterval(this.timesTimer);
        this.timesTimer = null;
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    async timerFuc() {
      let current_time = this.seconds;
      this.seconds = 0;
      await this.$http.post(
        "/api/app/remember/video/time",
        {
          chapter_id: this.period_id,
          time: this.currentTime,
          current_time: current_time,
        },
        { showLoading: false },
      );
    },
    initTimer() {
      this.timer = setTimeout(async () => {
        await this.timerFuc();
        if (!this.isPlay) {
          return;
        }
        this.initTimer();
      }, 5000);
    },
    async playNext() {
      let period = this.$refs.chapter.getNextPeriod(this.period_id);
      if (!period) {
        return;
      }
      await this.$services.CourseService.watchVideo(
        period,
        this.course_type,
        this.course_id,
      );
    },
    async play() {
      if (this.course_type != 5 && this.course_type != 8) {
        return;
      }
      if (this.video_id == "") {
        return;
      }
      let course_setting = (
        await this.$http.get("/api/app/config/course_setting")
      ).course_setting;
      let dataTime = await this.$http.get(
        "/api/app/video/time/" + this.period_id,
      );
      let params = {};
      if (this.parent) {
        params.system_course_id = this.parent;
      }
      let data = await this.$http.get(
        "/api/app/getPlayToken/chapter_id=" +
          this.period_id +
          "/course_id=" +
          this.course_id,
        params,
      );
      this.$refs.videoWrap.innerHTML =
        '<video id="videoplay" ref="videoplay" class="video video-js vjs-default-skin"></video>';
      // eslint-disable-next-line no-new
      new window.BjcPlayer(document.getElementById("videoplay"), {
        token: data.token,
        vid: data.video_id,
        privateDomainPrefix: data.private_domain,
        autoplay: true,
        currentTime: dataTime || 0,
        loop: course_setting.recorded_response_event == 3,
        onplay: () => {
          this.isPlay = true;
          this.initTimer();
        },
        onpause: () => {
          this.isPlay = false;
        },
        ontimeupdate: time => {
          this.currentTime = time.currentTime;
        },
        onended: () => {
          this.isPlay = false;
          if (course_setting.recorded_response_event == 1) {
            this.playNext();
          }
        },
      });
    },
  },
  watch: {
    $route: async function () {
      await this.init();
      await this.play();
    },
  },
  destroyed() {
    this.isPlay = false;
    this.clearTimer();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";
.main-container {
  padding: 10px 0 70px 0;
}
.video-left {
  width: 847px;
}
.chapters {
  background-color: white;
  padding: 20px 15px 10px 15px;
  width: 333px;
  box-sizing: border-box;
  max-height: 500px;
  overflow-y: auto;
  border-radius: 13px;
  /deep/ {
    .chapter-content {
      margin-bottom: 30px;
      &:first-child {
        padding-top: 0;
      }
      &.current {
        .period-title {
          color: $primary-color;
        }
        .period-point {
          background-color: $primary-color;
        }
        .period-try {
          background-image: url("~@/assets/images/video/try-active@3x.png");
        }
      }
      .period-title {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #595959;
        line-height: 20px;
        display: flex;
        align-items: center;
        float: none;
      }
      .period-title-content {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex-grow: 1;
      }
      .period-point {
        margin-top: 0;
        margin-right: 6px;
        background-color: #8c8c8c;
      }
      .period-try {
        margin-top: 0;
        margin-right: 8px;
        width: 34px;
        height: 16px;
        background-image: url("~@/assets/images/video/try@3x.png");
      }
    }
    .chapter-item {
      padding: 0;
      border-bottom: none;
      margin-bottom: 35px;
      &:last-child {
        margin-bottom: 0;
      }
      &.chapter-expand {
        .chapter-title {
          box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
          border-color: transparent;
          &::after {
            background-image: url("~@/assets/images/video/up@3x.png");
          }
        }
      }
      .chapter-title {
        box-sizing: border-box;
        height: 52px;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(38, 38, 38, 1);
        line-height: 52px;
        padding-left: 15px;
        margin-bottom: 20px;
        border: 1px solid rgba(238, 238, 238, 1);
        position: relative;
        &::after {
          content: "";
          position: absolute;
          width: 19px;
          height: 11px;
          top: 21px;
          right: 15px;
          background-size: 100% 100%;
          background-image: url("~@/assets/images/video/down@3x.png");
        }
      }
      .chapter-content {
        padding-left: 0;
      }
      .el-icon-caret-right,
      .el-icon-caret-bottom {
        display: none;
      }
    }
  }
}
</style>
<style lang="scss">
#videoplay {
  height: 500px;
  width: 100%;
  overflow: hidden;
}
</style>
